import setUserProfiles from "sh-stores/sh-userprofiles-store/actions/setUserProfiles";
import updateUserProfilesInStore from "sh-stores/sh-userprofiles-store/mutatorAction/updateUserProfilesInStore";
import { orchestrator } from "satcheljs";

export default orchestrator( setUserProfiles, async actionMessage => {
    // update the data in the store
    updateUserProfilesInStore(actionMessage.userProfiles);
});